import { createSelector } from '@ngrx/store'
import { FeaturesState } from '../../features.state'
import { selectFeatures } from '../../features.selectors'
import { adapter } from './kpiinstance.reducer'

export const selectKPIInstances = createSelector(
  selectFeatures,
  (state: FeaturesState) => state.kpisinstances
)

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors(selectKPIInstances)

export const getKPIInstanceById = (id: string) =>
  createSelector(selectEntities, (entities) => entities[id])
